//环信appKey默认配置项
//export const DEFAULT_EASEMOB_APPKEY = '1117231215169175#mnkuaw'
export const DEFAULT_EASEMOB_APPKEY =window.sessionStorage.getItem('webimConfig')
    ? JSON.parse(window.sessionStorage.getItem('webimConfig')).easymob.appkey
    : 'easemob#easeim'
export const DEFAULT_EASEMOB_SOCKET_URL = '//im-api-v2.easecdn.com/ws'
export const DEFAULT_EASEMOB_REST_URL = '//a1.easecdn.com'
